import { PLATFORMS } from '@/core/settings/constants';
import { getPlatform } from '@/core/settings/utils';
import { Option as NewOption } from '@/productDiscovery/Listings/components/Filters/components/newTamagoshiComponents/SelectInput/components/Option/Option';
import { SelectInput as NewSelectInput } from '@/productDiscovery/Listings/components/Filters/components/newTamagoshiComponents/SelectInput/SelectInput';
import { useSortFilter } from '@/productDiscovery/Listings/components/Filters/hooks/useSortFilter';

import { translations } from './translations';

import styles from './SortSelect.module.scss';

export const SortSelect = () => {
  const { sortItems, handleSortFilterSelection, activeLabel } = useSortFilter();

  const onChange = (event: KeyboardEvent | MouseEvent, value: string) => {
    const item = sortItems.find(({ label }) => label === value);
    if (item) handleSortFilterSelection(event, item);
  };

  return (
    <NewSelectInput
      id="SelectInput"
      label={`${translations.title}${
        getPlatform() === PLATFORMS.FRANCE ? ' ' : ''
      }`}
      onChange={onChange}
      value={activeLabel}
      optionsNumber={sortItems.length}
      className={styles.root}
    >
      {sortItems.map((item, i) => (
        <NewOption
          value={item.label}
          key={item.value}
          selected={item.label === activeLabel}
          index={i}
        >
          {item.label}
        </NewOption>
      ))}
    </NewSelectInput>
  );
};

SortSelect.displayName = 'SortSelect';
